import React from 'react';
import './footer.css'
import logo from '../../assets/logo.svg'
import FooterText from '../footercomponents/FooterText';
import facebook from "../../assets/facebook.svg";
import twitter from "../../assets/twitter.svg";
import instagram from "../../assets/instagram.svg";
import linked from "../../assets/linked.png";
import FooterLinks from '../footercomponents/FooterLinks';
import FooterTitle from '../footercomponents/FooterTitle';
import call2 from "../../assets/callwhite.svg";
import location2 from "../../assets/locationwhite.svg";
import mail2 from "../../assets/mailwhite.svg";

const Footer = () => {
    return ( <>
        <footer className='footer-container'>
            <div className='footer-text-box'>
            <div className='box1'>
            <img src={logo} alt='/'/>
            <FooterText text='Your trusted partner in finding the perfect property. Luxury homes, exceptional service.' style1='grey-text-2' />
            <div className="links-box">
            <FooterLinks img={facebook}/>
            <FooterLinks img={instagram} />
            <FooterLinks img={twitter} />
            <FooterLinks img={linked} />
            </div>
            </div>

            <div className='box1'>
                <FooterTitle text='Quick Links' style2='footer-title'/>
                <FooterText text='Home' style1='grey-text-3' />
                <FooterText text='Properties' style1='grey-text-3' />
                <FooterText text='About Us' style1='grey-text-3' />
                <FooterText text='Services' style1='grey-text-3' />
                <FooterText text='Contact' style1='grey-text-3' />
            </div>

            <div className='box1'>
                <FooterTitle text='Services' style2='footer-title'/>
                <FooterText text='Property Sales' style1='grey-text-3' />
                <FooterText text='Property Rentals' style1='grey-text-3' />
                <FooterText text='Property Management' style1='grey-text-3' />
                <FooterText text='Investment Consulting' style1='grey-text-3' />
                <FooterText text='Market Analysis' style1='grey-text-3' />
            </div>

            <div className='box1'>
                <FooterTitle text='Contact Us' style2='footer-title'/>
                <div className='contact-box'>
                    <img src={location2} alt='/' />
                <FooterText text='123 Luxury Avenue' style1='grey-text-3' />
                </div>
                <div className='contact-box'>
                <img src={call2} alt='/' />
                <FooterText text='+1 (234) 567-890' style1='grey-text-3' />
                </div>
                <div className='contact-box'>
                <img src={mail2} alt='/' />
                <FooterText text='info@estateflow.com' style1='grey-text-3' />
                </div>
            </div>
            </div>

            <div className='line'></div>

            <div className='last-box'>
            <FooterText text='© 2026 EstateFlow. All rights reserved.' style1='grey-text-3' />
            <div className='privacy-box'>
            <FooterText text='Privacy Policy' style1='grey-text-3' />
            <FooterText text='Terms of Service' style1='grey-text-3' />
            <FooterText text='Cookie Policy' style1='grey-text-3' />
            </div>
            </div>

        </footer>
    </> );
}
 
export default Footer;